import { getRequestHeaders, handleRes } from "utils";
import { System, Tenant } from "types";

export interface GetSystemResponse extends Response {
  systems?: Array<System>;
}

export const getSystems = async (): Promise<System[]> => {
  return fetch(`${window.USER_BASE_URL}/system`, {
    method: "GET",
    ...getRequestHeaders(),
  })
    .then((res) => handleRes<System[]>(res, 200))
    .catch((e) => {
      throw e;
    });
};

export const getSystemByID = async (
  systemID: string | undefined,
): Promise<System> => {
  return fetch(`${window.USER_BASE_URL}/system/${systemID}`, {
    method: "GET",
    ...getRequestHeaders(),
  })
    .then((res) => handleRes<System>(res, 200))
    .catch((e) => {
      throw e;
    });
};

export const getSystemTenants = (systemID: number): Promise<Tenant[]> => {
  return fetch(`${window.USER_BASE_URL}/system/${systemID}/tenant`, {
    method: "GET",
    ...getRequestHeaders(),
  })
    .then((res) => handleRes<Tenant[]>(res, 200))
    .catch((e) => {
      throw e;
    });
};

interface UpdateSystemParams {
  body: string; // System as JSON string,
  systemID: number;
}
export const updateSystem = async ({
  body,
  systemID,
}: UpdateSystemParams): Promise<GetSystemResponse> => {
  return await fetch(`${window.USER_BASE_URL}/system/${systemID}`, {
    method: "PUT",
    ...getRequestHeaders(),
    body,
  });
};

export const createSystem = async (
  body: string, // System as JSON string,
): Promise<GetSystemResponse> => {
  return await fetch(`${window.USER_BASE_URL}/system`, {
    method: "POST",
    ...getRequestHeaders(),
    body,
  });
};
